export const calculatePercentageChange = (
  yesterdayValue: number,
  todayValue: number,
): string => {
  const difference = todayValue - yesterdayValue
  const percentage = (difference / yesterdayValue) * 100
  return percentage.toFixed(2)
}
